import { useMutation, useQuery } from "@tanstack/react-query";
import type { Sort } from "@unbox/api";
import { handleError } from "@/api/error";
import { type Pagination, toQuery } from "@/api/pagination";
import { client } from "../client";

export type AdsSort = Sort<"id" | "name" | "createdAt">;

export const useAdminAds = (pagination: Pagination, sort: AdsSort, { text }: { text?: string }) => {
  return useQuery({
    queryKey: ["admin", "ads", pagination.limit, pagination.offset, sort.column, sort.direction, text],
    queryFn: async () => {
      const res = await client.admin.ads.$get({
        query: {
          ...toQuery(pagination),
          ...sort,
          text,
        },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};

// Runs the live S3 + TikTok auth check for one brand and returns the result.
// Nothing is persisted server-side; callers hold the result in component state.
export const refreshAdsStatus = async (merchantId: string) => {
  const res = await client.admin.ads[":merchantId"].refresh.$post({ param: { merchantId } });
  if (!res.ok) throw await handleError(res);
  return await res.json();
};

export type AdsAuthStatus = Awaited<ReturnType<typeof refreshAdsStatus>>;

export const useRefreshAdsStatus = () => useMutation({ mutationFn: refreshAdsStatus });
